import { render, staticRenderFns } from "./ContestInstructions2.vue?vue&type=template&id=7d4f06ac&scoped=true&"
import script from "./ContestInstructions2.vue?vue&type=script&lang=js&"
export * from "./ContestInstructions2.vue?vue&type=script&lang=js&"
import style0 from "./ContestInstructions2.vue?vue&type=style&index=0&id=7d4f06ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4f06ac",
  null
  
)

export default component.exports